export const weekDays = {
    1: 'man',
    2: 'tirs',
    3: 'ons',
    4: 'tors',
    5: 'fre',
    6: 'lør',
    0: 'søn'
};
export const monthStrShort = {
    0: 'Jan',
    1: 'Feb',
    2: 'Mar',
    3: 'Apr',
    4: 'Mai',
    5: 'Jun',
    6: 'Jul',
    7: 'Aug',
    8: 'Sep',
    9: 'Okt',
    10: 'Nov',
    11: 'Des'
};
export const monthStrFull = {
    0: 'Januar',
    1: 'Februar',
    2: 'Mars',
    3: 'April',
    4: 'Mai',
    5: 'Juni',
    6: 'Juli',
    7: 'August',
    8: 'September',
    9: 'Oktober',
    10: 'November',
    11: 'Desember'
};

export const getISOWeeksAmount = (y) => {
    var d, isLeap;

    d = new Date(y, 0, 1);
    isLeap = new Date(y, 1, 29).getMonth() === 1;

    // check for a Jan 1 that's a Thursday or a leap year that has a
    // Wednesday jan 1. Otherwise it's 52
    return d.getDay() === 4 || (isLeap && d.getDay() === 3) ? 53 : 52;
};

export const offsetBasedOnWeek = (targetWeek, targetYear) => {
    targetWeek = Number(targetWeek);
    targetYear = Number(targetYear);

    const currentDate = new Date();
    const currentWeek = ISO8601_week_no(currentDate);
    const currentYear = currentDate.getFullYear();
    const weekInMiddle = 2; // Assuming this is meant to center the range around the current week

    let offset = 0;

    if (currentYear === targetYear) {
        // Case 1: The target week is in the current year
        offset = targetWeek - currentWeek;
    } else if (currentYear < targetYear) {
        // Target year is in the future
        const weeksRemainingInCurrentYear =
            getISOWeeksAmount(currentYear) - currentWeek;
        const weeksUntilTargetWeekInTargetYear = targetWeek - 1;
        offset = weeksRemainingInCurrentYear + weeksUntilTargetWeekInTargetYear;

        // Add weeks for the full years in between
        for (let year = currentYear + 1; year < targetYear; year++) {
            offset += getISOWeeksAmount(year);
        }
    } else {
        // Target year is in the past
        const weeksPassedInTargetYear =
            getISOWeeksAmount(targetYear) - targetWeek;

        const weeksPassedInCurrentYear = currentWeek - 1;
        offset = -(weeksPassedInTargetYear + weeksPassedInCurrentYear);
        // Subtract weeks for the full years in between
        for (let year = targetYear + 1; year < currentYear; year++) {
            offset -= getISOWeeksAmount(year);
        }
    }

    offset -= weekInMiddle;
    return offset;
};

export const datesAreOnSameDay = (first, second) =>
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();

export const returnDateInfo = (myDate) => {
    let start;
    if (myDate) {
        if (myDate instanceof Date || typeof myDate === 'number') {
            start = new Date(myDate);
        } else if (typeof myDate === 'string') {
            start = new Date(myDate.replace(/-/g, '/').replace(/T/g, ' '));
        }
    }
    if (!start) start = new Date();

    const mDay = ('0' + start.getDate()).slice(-2);
    const getMonth = start.getMonth();
    const mMonth = ('0' + (getMonth + 1)).slice(-2);
    const yYear = ('202' + start.getFullYear()).slice(-4);
    const hr = ('0' + start.getHours()).slice(-2);
    const min = ('0' + start.getMinutes()).slice(-2);
    const intDay = start.getDay(); //0 is sunday, 1 is monday - 6 is saturday...
    const dayStr = weekDays[intDay.toString()] || '';
    const week = ('0' + ISO8601_week_no(start)).slice(-2);

    const ret = {
        year: yYear,
        month: mMonth,
        monthStr: monthStrFull[getMonth] || '',
        monthStrShort: monthStrShort[getMonth] || '',
        day: mDay,
        hour: hr,
        minute: min,
        dayInt: intDay,
        dayStr: dayStr,
        week: week,
        dateVar: start
    };
    return ret;
};

export const localeTime = (myDate) => {
    const objTime = returnDateInfo(myDate);
    return `${objTime.year}-${objTime.month}-${objTime.day}T${objTime.hour}:${objTime.minute}`;
};

export const strDateTime = (myDate) => {
    const objTime = returnDateInfo(myDate);

    return `${objTime.year}-${objTime.month}-${objTime.day} ${objTime.hour}:${objTime.minute}`;
};
export const strddmmyyyyhhMM = (myDate, getDay) => {
    const objTime = returnDateInfo(myDate);

    return `${getDay ? objTime.dayStr + ' ' : ''}${objTime.day}-${
        objTime.month
    }-${objTime.year} ${objTime.hour}:${objTime.minute}`;
};

export const strDateView = (mDate) => {
    const objTime = returnDateInfo(mDate);

    return `${objTime.day}-${objTime.month}-${objTime.year}`;
};

export const isInPast = (selDate) => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    if (selDate < now) {
        return true;
    } else {
        return false;
    }
};

export const strDateYYYYmmDD = (mDate) => {
    const objTime = returnDateInfo(mDate);

    return `${objTime.year}-${objTime.month}-${objTime.day}`;
};

export const strDateHHMM = (date) => {
    const objTime = returnDateInfo(date);

    return `${objTime.hour}:${objTime.minute}`;
};

export const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
};

export const ISO8601_week_no = (dt) => {
    var tdt = new Date(dt.valueOf());
    var dayn = (dt.getDay() + 6) % 7;
    tdt.setDate(tdt.getDate() - dayn + 3);
    var firstThursday = tdt.valueOf();
    tdt.setMonth(0, 1);
    if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay() + 7) % 7));
    }
    return 1 + Math.ceil((firstThursday - tdt) / 604800000);
};

export function getISOWeekNumber(m, y) {
    // Create a date for the first day of the given month and year
    const firstDayOfMonth = new Date(y, m, 1);

    // Calculate the day number of the year for the first day of the month
    const dayOfYear =
        Math.floor(
            (firstDayOfMonth - new Date(y, 0, 1)) / (24 * 60 * 60 * 1000)
        ) + 1;

    // Calculate the day of the week for the first day of the year
    const firstDayOfYear = new Date(y, 0, 1);
    const dayOfWeek = firstDayOfYear.getDay() || 7; // Sunday is 7, not 0

    // ISO weeks start on Monday, so we might need to adjust the day count
    let dayAdjustment = dayOfWeek - 1;
    if (dayOfWeek > 4) dayAdjustment -= 7; // If the year starts on Fri, Sat, or Sun, the first week belongs to the previous year

    // Calculate the ISO week number
    const isoWeek = Math.ceil((dayOfYear - dayAdjustment) / 7);

    return isoWeek;
}

export const weekDateToDate = (year, week, day) => {
    const firstDayOfYear = new Date(year, 0, 1);
    const days = 2 + day + (week - 1) * 7 - firstDayOfYear.getDay();
    return new Date(year, 0, days);
};

export const returnWeekInfo = (weekCode) => {
    let retObj = {};

    if (weekCode && weekCode.length > 0) {
        const spl = weekCode.toLowerCase().split('w');
        if (spl.length > 1) {
            retObj['week'] = spl[1];
            retObj['year'] = spl[0];
        }
    }
    return retObj;
};

export const weekLabel = (weekCode, ignoreWeekLbl) => {
    let retStr = weekCode || '';
    const obj = returnWeekInfo(weekCode);
    if (obj.week)
        retStr =
            (ignoreWeekLbl ? '' : 'Uke ') +
            obj.week +
            ` / ${obj.year.slice(-2)}`;

    return retStr;
};

export const getInfoWeek = (week) => {
    if (week) {
        const dateInf = returnDateInfo(week.startW);
        const dateEnd = returnDateInfo(week.endW);

        const retObj = {
            monthLine:
                dateInf.monthStr !== dateEnd.monthStr
                    ? `${dateInf.monthStr}/${dateEnd.monthStr}`
                    : dateInf.monthStr,
            dateLine: `${dateInf.day} - ${dateEnd.day}`
        };
        return retObj;
    }
    return {};
};

export const getDateOfISOWeek = (w, y) => {
    const simple = new Date(y, 0, 1 + (w - 1) * 7);
    const dow = simple.getDay();
    let ISOweekStart = simple;
    if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());

    ISOweekStart.setHours(12, 0, 0);
    let ISOweekEnd = new Date(ISOweekStart);
    ISOweekEnd.setDate(ISOweekStart.getDate() + 7);
    ISOweekEnd.setHours(12, 0, 0);
    return { from: ISOweekStart, to: ISOweekEnd };
};

export const getDiffDays = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const difference = end.getTime() - start.getTime();
    const diffInDays = difference / (1000 * 3600 * 24);

    return diffInDays;
};
export const getDiffHours = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const difference = end.getTime() - start.getTime();
    const diffInHours = difference / (1000 * 3600);
    return diffInHours;
};
export const getDiffQuarterDays = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const difference = end.getTime() - start.getTime();
    const diffInQuarterDays = difference / (1000 * 3600 * 6);
    return diffInQuarterDays;
};
export const getDiffHalfDays = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const difference = end.getTime() - start.getTime();
    const diffInHalfDays = difference / (1000 * 3600 * 12);
    return diffInHalfDays;
};
export const getMonday = (d) => {
    d = new Date(d);
    const day = d.getDay();
    const diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    let retDate = new Date(d.setDate(diff));
    retDate.setHours(0, 0, 0);

    retDate = returnDateInfo(retDate);
    return retDate;
};

export const fourthWeekNextYearDate = () => {
    const now = new Date();
    const nextYear = now.getFullYear() + 1;
    const fourthWeekNextYear = new Date(nextYear, 0, 1);
    fourthWeekNextYear.setDate(fourthWeekNextYear.getDate() + 21);
    const dayOfWeek = fourthWeekNextYear.getDay();
    const difference = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    fourthWeekNextYear.setDate(fourthWeekNextYear.getDate() - difference);
    const mondayForthWeek = new Date(fourthWeekNextYear);
    return mondayForthWeek;
};

export const mondayOfWeekAndYear = (week, year) => {
    // ISO 8601: uke 1 er uka som inneholder 4. januar. Å telle uker fra 1.
    // januar gir feil uke i år der 1. januar faller på fredag, lørdag eller
    // søndag (f.eks. 2027 og 2028), fordi den uka tilhører forrige år.
    const jan4 = new Date(year, 0, 4);
    const dayOfWeek = jan4.getDay() === 0 ? 7 : jan4.getDay(); // man=1 ... søn=7
    const mondayDate = new Date(year, 0, 4 - (dayOfWeek - 1));
    mondayDate.setDate(mondayDate.getDate() + (week - 1) * 7);
    return mondayDate;
};
